import BusinessDetail from './BusinessDetail';

export default function BusinessDetailPage() {
  return (
    <BusinessDetail />
  );
}